@if (selectedElectionPeriodEvent?.value) {
  <div>
    <h4><strong>Effective Date & Enrollment Election</strong></h4>
    <p>{{selectedElectionPeriodEvent.value}}</p>
    @if (!formConfig.form.customConfigs?.reviewOnly) {
      <button mat-raised-button class="edit-button" color="secondary" (click)="editQuestion()">Edit</button>
    }
  </div>
}